import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SimplyReliable() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll();
  return <section data-section-id="17079" id="elevating-your-everyday-wellness" className="relative w-full overflow-hidden bg-background text-foreground py-12 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-center lg:gap-16">
          <div ref={textRef} className={`flex flex-1 flex-col justify-center transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <h1 className="font-sans text-6xl font-bold leading-tight tracking-tighter text-foreground sm:text-8xl lg:text-9xl">
              Elevating Your Everyday Wellness
            </h1>
            <p className="mt-6 max-w-xl text-xl font-medium tracking-tight text-muted-foreground md:text-2xl lg:text-3xl">
              Medical precision meets modern design.
              <br />
              <span className="text-primary">Your journey to wellness starts here.</span>
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Button asChild size="lg" className="group relative h-14 overflow-hidden rounded-full bg-primary px-10 text-lg font-semibold text-primary-foreground shadow-lg shadow-primary/20 transition-transform duration-300 hover:scale-105 active:scale-95">
                <Link to="/ProfessionalMedicalPage">
                  <span className="relative z-10 flex items-center gap-2">
                    Shop Collections
                    <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Link>
              </Button>
            </div>
          </div>

          <div ref={imgRef} className={`relative flex w-full max-w-md flex-none justify-center lg:w-[40%] lg:max-w-none transition-all duration-1000 delay-300 ease-out ${imgVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            <div className="relative aspect-[3/4] w-full overflow-hidden rounded-3xl shadow-[0_0_50px_rgba(59,130,246,0.3)]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592322/img/ok_storefront_vertical.png" alt="okfun scalp massager lifestyle shot with a soft blue aura" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}